/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import ReactToPrint from 'react-to-print';
import {
    useParams
} from "react-router-dom";
import { InputText } from 'primereact/inputtext';

import './PDFTemplate.scss'

const PDFTemplate = (parmas) => {

    const { ComponentToPrint, habilitarInprimir = true, margin = '0.1in 0.1in 0.1in 0.1in' } = parmas;

    const { Numero, Seccion } = useParams();
    const componentRef = useRef(null);
    const [toShow, setToShow] = useState('')

    // const [margin, setMargin] = useState()
    const [size, setSize] = useState();
    const [scale, setScale] = useState(null);
    const [translate, setTranslate] = useState();


    useEffect(() => {
        // setMargin('0.1in 0.1in 0.1in 0.1in')
        setSize('8.5in 11in');
        setScale('0.4');
        setTranslate('0px, 0px');
    }, [])

    useEffect(() => {
        console.log(`@page { size: ${size}; margin: ${margin}; }`)
    }, [])

    // useEffect(() => {
    //     template();
    // }, [Numero, ComponentToPrint, size, scale, translate, Seccion])


    const template = () => {
        if (Numero) {
            return (
                <div style={{ height: '100%' }} >

                    <div style={{ height: '100%' }}>
                        <div className='col-12 d-flex justify-content-center p-2' style={{ alignItems: 'center' }} >
                            <ReactToPrint
                                trigger={() => <Button icon="pi pi-print" type="button" className="p-button-primary listado__botones" 
                                    tooltip="Imprimir" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 2, zIndex: 10000 }} />}
                                content={() => componentRef.current}
                                pageStyle={`@page { size: ${size}; margin: ${margin}; }`}
                                documentTitle={''}
                                removeAfterPrint={true}

                            />
                            {/* <Button icon="pi pi-arrow-circle-down" type="button" className="p-button-info listado__botones" onClick={printCanvas}
                                tooltip="Descargar" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 2 }} /> */}
                        </div>
                        <div className='d-flex'>
                            <div>
                                <p>Size</p>
                                <InputText id='size' value={size} onChange={(e) => setSize(e.target.value)} />
                            </div>
                            <div>
                                <p>scale</p>
                                <InputText value={scale} onChange={(e) => setScale(e.target.value)} />
                            </div>
                            <div>
                                <p>translate</p>
                                <InputText value={translate} onChange={(e) => setTranslate(e.target.value)} />
                            </div>
                        </div>
                        <div style={{ height: '80vh', overflowY: 'scroll' }}>
                            <div style={{ height: '100%', transform: Seccion ? `rotate(90deg) scale(${scale}) translate(${translate})` : '' }} ref={componentRef}>
                                <ComponentToPrint Numero={Numero} Seccion={Seccion} />
                            </div>
                        </div>
                    </div>
                </div>

            );
        } else {
            return (<div style={{ height: '100%', widows: '100%' }} >
                <div style={{ height: '100%' }}>
                    <div className='col-12 d-flex justify-content-center p-2' style={{ alignItems: 'center' }} >
                        {habilitarInprimir && <ReactToPrint
                            trigger={() => <Button icon="pi pi-print" type="button" className="p-button-primary listado__botones"
                                tooltip="Imprimir" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 2 }} />}
                            content={() => componentRef.current}
                            pageStyle={`@page { size: ${size}; margin: ${margin}; }`}
                            documentTitle={''}
                            removeAfterPrint={true}
                        />}
                        {/* <Button icon="pi pi-arrow-circle-down" type="button" className="p-button-info listado__botones" onClick={printCanvas}
                                tooltip="Descargar" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 2 }} /> */}
                    </div>
                    <div style={{ padding: 20, marginTop: 100 }}>
                        <div ref={componentRef} >
                            <ComponentToPrint Numero={Numero} Seccion={Seccion} />
                        </div>
                    </div>
                </div>

            </div>);
        }
    }
    return (
        <div>
            {template()}
        </div>
    )
}

export default PDFTemplate